module.exports = __webpack_public_path__ + "img/pickup-confirmation-cancel.fde17d05.svg";